module.exports = __webpack_public_path__ + "static/media/maci_header.72ef6e41.png";